import React, { useEffect, useState } from 'react';
import { StyleSheet, View } from 'react-native';
import { Color, CommonProperties, CommonStyles } from '../../styles';
import { scale } from '../../utils/scale.utils';
import Button from '../Button';
import SearchTypeCheckbox from '../TripSearchWidget/SearchTypeCheckbox';
import RowView from '../RowView';
import { useNavigation, useRoute } from '@react-navigation/core';
import { Modals } from '../../constants/ScreenNames';
import CheckboxSquare from '../CheckboxSquare';
import EventUploadModal from '../TripHub/Event/EventUploadModal';
import useEventWidget from '../../utils/useEventWidget';
import { useSelector } from 'react-redux';
import { selectUserProfile, selectUserProfileImage } from '../../store/selectors/profile.selector';
import EventFormWidget from './EventFormWidget';

const EventWidget = ({ openUploadImage = false, onChange }) => {
  const navigation = useNavigation();
  const route = useRoute();
  const userProfile = useSelector(selectUserProfile);
  const userImage = useSelector(selectUserProfileImage);
  const [state, dispatch, openCalendar, , sideState] = useEventWidget();
  const { isAir, isHotel, isDrive, isVirtual } = state;
  const [showUploadModal, setShowUploadModal] = useState(false);

  const onUpdateImages = (value) => {
    dispatch({ type: 'setImages', value });
    setShowUploadModal(false);
  };

  const onSubmit = (e) => {
    e.preventDefault();
    if (state.hasDescription || state.hasMeeting || state.Speaker) {
      navigation.navigate(Modals.EventSettingsModal, {
        returnScreen: route.name,
        event: state,
        disableDescription: !state?.hasDescription,
      });
    } else {
      const user = {
        name: `${userProfile.FirstName} ${userProfile.LastName}`,
        url: userImage,
      };
      navigation.navigate(Modals.EventPreviewModal, { event: state, user });
    }
  };

  const onCloseModal = () => {
    setShowUploadModal(false);
    if (onChange) {
      onChange(state);
    }
  };

  useEffect(() => {
    if (onChange) {
      onChange(state);
    }
  }, [state, onChange]);

  useEffect(() => {
    setShowUploadModal(openUploadImage);
  }, [openUploadImage]);

  return (
    <View style={[CommonStyles.mx3, CommonStyles.mb5]}>
      <EventUploadModal
        visible={showUploadModal}
        onUpdate={onUpdateImages}
        onClose={onCloseModal}
      />
      <View style={styles.searchTypeRowWrap}>
        <View style={styles.searchTypeRow}>
          <SearchTypeCheckbox
            selected={isAir}
            iconName="flight"
            onPress={() => dispatch({ type: 'setIsAir' })}
          />
          <SearchTypeCheckbox
            selected={isHotel}
            iconName="hotel"
            onPress={() => dispatch({ type: 'setIsHotel' })}
          />
          <SearchTypeCheckbox
            selected={isDrive}
            iconName="mark"
            onPress={() => dispatch({ type: 'setIsDrive' })}
          />
          <SearchTypeCheckbox
            selected={isVirtual}
            iconName="meetingPlatform"
            onPress={() => dispatch({ type: 'setIsVirtual' })}
          />
        </View>
      </View>
      <EventFormWidget
        state={state}
        dispatch={dispatch}
        sideState={sideState}
        openCalendar={openCalendar}
      />
      <RowView style={styles.checkboxSection}>
        {!sideState.isOnlyVirtual ? (
          <CheckboxSquare
            label="Description"
            value={state.hasDescription}
            onChange={() => dispatch({ type: 'setHasDescription' })}
          />
        ) : null}
        <CheckboxSquare
          label="Meetings"
          value={state.hasMeeting}
          onChange={() => dispatch({ type: 'setHasMeeting' })}
        />
        <CheckboxSquare
          label="Speakers"
          value={state.hasSpeaker}
          onChange={() => dispatch({ type: 'setHasSpeaker' })}
        />
      </RowView>
      <Button
        style={styles.submitButton}
        label="Continue"
        labelStyle={CommonStyles.h2}
        onPress={onSubmit}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  searchTypeRowWrap: {
    ...CommonProperties.mt2,
    ...CommonProperties.mb3,
    ...CommonProperties.borderRadius,
    ...CommonProperties.shadow,
  },
  searchTypeRow: {
    height: scale(52),
    flexDirection: 'row',
    justifyContent: 'space-between',
    backgroundColor: Color.accent,
    overflow: 'hidden',
    ...CommonProperties.borderRadius,
  },
  widgetContainer: {
    backgroundColor: Color.accent,
    ...CommonProperties.mt2,
    ...CommonProperties.mb3,
    ...CommonProperties.borderRadius3,
    ...CommonProperties.shadow,
  },
  submitButton: {
    ...CommonProperties.mt5,
    ...CommonProperties.py3,
    ...CommonProperties.shadow,
    ...CommonProperties.borderRadius4,
  },
  topBorder: {
    borderTopWidth: 0.5,
    borderTopColor: Color.text.low,
  },
  checkboxSection: {
    justifyContent: 'space-around',
    ...CommonProperties.my3,
  },
});

export default EventWidget;
